<template>
  <div class="pc-head" :class="{ 'not-home': props.notHome }">
    <div class="content flex-center-stright">
      <div class="logo-box flex-center">
        <!-- <img :src="logo_h" class="logo" v-if="!props.notHome" /> -->
        <!-- <img :src="logo" class="logo" v-if="props.notHome" /> -->
      </div>
      <Search v-if="props.notHome"></Search>
      <pc-nav :notHome="props.notHome"></pc-nav>
    </div>
    <div class="notHome-bg"></div>
  </div>
</template>

<script setup>
import Search from "../common/Search";
import PcNav from "./Nav.vue";

const logo_h = require(`../../assets/img/common/${process.env.VUE_APP_LOGO}`);
const logo = require(`../../assets/img/common/${process.env.VUE_APP_LOGO_NOTHOME}`);
const props = defineProps({
  notHome: Boolean,
});
</script>

<style lang="scss">
.pc-head {
  height: 70px;
  min-width: 1250px;
  background: $home_head;
  border-bottom: 1px solid #5053ce;

  .logo-box {
    display: inline-flex;
    height: 55px;

    .logo {
      max-height: 60px;
    }
  }

  .content {
    position: relative;
    width: 1250px;
    height: 100%;
    padding: 0 25px;
    margin: 0 auto;

    .head-nav {
      position: absolute;
      height: 70px;
      width: 650px;
      top: 0;
      right: 0;
      color: $white;
      font-size: 14px;
      font-weight: 500;
      font-family: PingFangSC-Medium;
    }
  }
}

.not-home {
  position: relative;
  background: $white;
  height: 120px;
  box-shadow: 0px 2px 4px 0px rgba(231, 238, 244, 1);

  .notHome-bg {
    width: 100%;
    height: 64px;
    position: absolute;
    top: 55px;
    left: 0;
    background: $home_head;
  }

  .content {
    display: block;

    .logo {
      // margin: 10px 0 0 12px;
    }

    .head-nav {
      top: 53px;
      left: 0;
      bottom: 0;
      color: $white;
    }
  }
}

// 动画区</style>
